import { render } from "./S3FileExplorer.vue?vue&type=template&id=134ee6ac"
import script from "./S3FileExplorer.vue?vue&type=script&lang=js"
export * from "./S3FileExplorer.vue?vue&type=script&lang=js"

import "./S3FileExplorer.vue?vue&type=style&index=0&id=134ee6ac&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__